import { INTEGRATION_PROVIDERS } from '@vy/types';
import { FC, useState } from 'react';
import { useInvoiceProductsIntegrations } from '../../../../../../../../../../../hooks/requests/use-invoice-products-integrations';
import { Box, Button, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { isNotEmptyString } from '@vy/utils';
import { useQuickBooksProducts } from '../../../../../../../../../../../hooks/requests/integrations';
import { EditQuickbooksProductDialog } from './EditQuickbooksProductDialog';

type QbInvoiceProductsAccordionContentProps = {
  invoiceId: string;
  disabled: boolean;
};

export const QbInvoiceProductsAccordionContent: FC<QbInvoiceProductsAccordionContentProps> = ({
  invoiceId,
  disabled,
}) => {
  const { data: invoiceProductsIntegrations } = useInvoiceProductsIntegrations(
    invoiceId,
    INTEGRATION_PROVIDERS.quickBooks,
    {
      suspense: true,
    },
  );

  const { data: quickBooksProducts } = useQuickBooksProducts();

  const [openDialogId, setOpenDialogId] = useState<string | null>(null);
  const products = invoiceProductsIntegrations?.products ?? [];

  const handleOpen = (productId: string) => {
    setOpenDialogId(productId);
  };

  const handleClose = () => {
    setOpenDialogId(null);
  };

  return (
    <Stack direction="column" sx={{
      gap: "16px"
    }}>
      {products.map((product) => {
        const hasQbMapping = isNotEmptyString(product.externalId);

        return (
          <Box
            key={product.id}
            sx={{
              border: '1px solid #E8EBF2',
              borderRadius: '10px',
              overflow: 'hidden',
            }}
          >
            <Stack
              direction="row"
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: '#F5F6FA',
                padding: '0 16px',
                height: '32px'
              }}>
              <Typography
                sx={{
                  lineHeight: "20px",
                  fontSize: "14px",
                  color: "text.secondary"
                }}>
                {product.name}
              </Typography>
              <Button
                variant="text"
                size="small"
                startIcon={<VyIcon icon={hasQbMapping ? 'Pen' : 'PlusMedium'} />}
                disabled={disabled}
                onClick={() => handleOpen(product.id)}
                sx={{ fontSize: '12px', lineHeight: '16px' }}
              >
                {hasQbMapping ? 'Edit' : 'Add'}
              </Button>
            </Stack>
            <Stack
              direction="column"
              sx={{
                gap: "8px",
                padding: '15px 16px'
              }}>
              {hasQbMapping ? (
                isNotEmptyString(product.externalName) && (
                  <Typography
                    sx={{
                      lineHeight: "20px",
                      fontSize: "14px"
                    }}>
                    <Box component="span" sx={{
                      fontWeight: 600
                    }}>
                      QB Name:
                    </Box>{' '}
                    {product.externalName}
                  </Typography>
                )
              ) : (
                <Typography
                  sx={{
                    lineHeight: "20px",
                    fontSize: "14px",
                    color: "text.secondary"
                  }}>
                  No custom fields here. Click Add to add
                </Typography>
              )}
            </Stack>
            <EditQuickbooksProductDialog
              open={openDialogId === product.id}
              onClose={handleClose}
              productId={product.id}
              externalProductId={product.externalId}
              quickBooksProducts={quickBooksProducts?.products ?? []}
            />
          </Box>
        );
      })}
    </Stack>
  );
};
